import { post, get } from './config/$ajax.js';
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};

export const login = function (data, url = '/account/login') {
  if (url === '/account/loginPhoneCode') {
    return post(url, data, { isNeedLoading: false, isNeedFailNotice: true, submitType: 'json' });
  }
  return post(url, data, { isNeedLoading: false });
};

export const getPhoneCode = function (data) {
  return post('/account/getPhoneCode', data);
};

export const logout = function () {
  return post('/account/logout', {}, { isNeedLoading: false });
};

export const choose = function (data) {
  return post('/account/setLoginIdentity', data);
};

export const getPicValiCode = function (key) {
  return get(
    '/account/loginGainValidateCode',
    {
      key: key || 'l',
      date: new Date().valueOf(),
    },
    { isNeedLoading: false }
  );
};

// export const checkCompanyExists = function(companyName) {
//   return post('/account/checkCompanyExists', {
//     companyName
//   }, {isNeedLoading: false})
// }

export const checkPhoneExists = function (phoneNum) {
  return post(
    '/account/checkPhoneExists',
    {
      phoneNum,
    },
    { isNeedLoading: false }
  );
};

export const getTelCode = function (data) {
  return post('/account/gainIdentifyCode', data, { isNeedLoading: false });
};

export const register = function (data) {
  let href = sessionStorage.getItem('_share_location_');
  if (href) {
    var reg = new RegExp('(^|&)inviteId=([^&]*)(&|$)');
    var r = href?.split('?')[1]?.match(reg);
    let supplierId = decodeURIComponent(r[2]);
    if (supplierId) {
      data.supplierId = supplierId;
    }
  }

  return post(`/account/register?date=${new Date().valueOf()}`, data);
};

export const userInfo = function () {
  return get('/user/querySupplyUserInfo', {}, { isNeedLoading: false, noTips: true });
};

export const erpUserInfo = function () {
  return getAjax('user/info', {}, { isNeedLoading: false, noTips: true });
};

// 获取oss所需相关数据
export const getOSSData = function () {
  return get(
    '/storage/oss/getStsToken',
    { tokenNew: 1 },
    { appJson: true, submitType: 'json', isNeedLoading: false, isNeedFailNotice: true }
  );
};

// 获取店铺授权失效信息
export const getWarning = function () {
  return get('/user/notice/warn', {}, { isNeedLoading: false, noTips: false });
};

// 查询提示是否需要展示
export const tipNeedShow = function (data) {
  return get('/tip/staffNeedShow', data, { isNeedLoading: false, noTips: false });
};

// 获取公司信息
export const getCompanyInfo = function () {
  return get('/user/getCompanyInfo', {}, { isNeedLoading: false, noTips: true });
};

// 切换供分销身份
export const setUserIdentity = function (data) {
  return post('/userIdentity/set', data, { appJson: true, submitType: 'json' });
};
/**
 * 发送登录短信验证码
 * @param {*} data 参数
 * @returns
 */
export const sendLoginSmsCode = data => {
  return post('/account/sendLoginPhoneCode', data, {
    appJson: true,
    submitType: 'json',
  });
};
/**
 * 忘记密码第一步
 * @param {*} data 参数
 * @returns
 */
export const forgetPasswordStep1 = data => {
  return postAjax('account/checkAdminAccount', data);
};
/**
 * 忘记密码需要获取图形验证码
 * @param {*} key
 * @returns
 */
export const forgetPasswordGetPicValiCode = function (key = 'f') {
  return `${API_HOST}gainValidateCode?key=${key}&_t=${new Date().valueOf()}`;
};
/**
 * 忘记密码需要获取图形验证码
 * @param {*} key
 * @returns
 */
export const forgetPasswordGetSmsValiCode = function (data) {
  return postAjax('account/gainIdentifyCode', data);
};
/**
 * 忘记密码第二步
 * @param {*} data 参数
 * @returns
 */
export const forgetPasswordStep2 = data => {
  return postAjax('account/checkIdentifyCode4FindPassword', data);
};
/**
 * 忘记密码第三步
 * @param {*} data 参数
 * @returns
 */
export const forgetPasswordStep3 = data => {
  return postAjax('account/updatePassword4Admin', data);
};

export const damPath = data => {
  return getAjax('index/auth/damPath', data);
};
